import config from './config/dashboard'
import axios from '@/utils/request'
export const getCollegeNews = params => axios.post(config.collegeNews, params)
export const salesData = params => axios.post(config.salesData, params)
export const salesCountRank = params => axios.post(config.salesCountRank, params)
export const salesDynamic = params => axios.post(config.salesDynamic, params)
